export const getHalfWidth = (width: number | string = '100%') => {
  return { width: `calc(${width}/2)` };
};

export const getGapWidthInPixels = (value: number) => {
  return { gap: value + 'px' };
};
